import { Flex, Skeleton, Stack, Text, TextInput } from "@mantine/core";
import { type JSX, useCallback } from "react";

import { useSessionSummaryStore } from "../store/useSessionSummaryStore";

interface SessionSubjectProps {
    loading: boolean;
}

export function SessionSummarySubject({ loading }: SessionSubjectProps): JSX.Element | null {
    const subject = useSessionSummaryStore((state) => state.subject);
    const submitted = useSessionSummaryStore((state) => state.submitted);
    const autogeneratedSummary = useSessionSummaryStore((state) => state.autogeneratedSummary);

    const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        useSessionSummaryStore.getState().setSubject(event.target.value);
    }, []);

    return (
        <Stack gap={0} mb="md">
            <Text size="xs" mb=".5rem">
                Subject
            </Text>
            {loading ? (
                <Flex direction="column" align="center" h="40">
                    <Skeleton mb="xxs" h="100%" />
                </Flex>
            ) : (
                <TextInput
                    styles={{
                        input: {
                            fontSize: "var(--mantine-font-size-xs)",
                        },
                    }}
                    value={subject}
                    disabled={submitted || !!autogeneratedSummary}
                    onChange={handleChange}
                    placeholder="Enter subject"
                />
            )}
        </Stack>
    );
}
